import actionTypes from '../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_PACK_DETAILS_SUCCESS:
      return { ...action.packDetails };
    case actionTypes.RESET_DETAILS_DIALOG_DATA:
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/reducers/pack-details.js